<template>
  <fieldset class="radio-group">
    <legend
      v-if="legend"
      class="flex w-full items-center justify-between text-sm font-bold"
      :class="[darkMode ? 'text-text-light lg:text-text-dark' : 'text-text-dark']"
    >
      {{ legend }}
      <span v-if="optional" class="text-xs font-normal">[{{ optional }}]</span>
    </legend>

    <div v-for="option in options" :key="option.value" class="radio-option">
      <input
        :id="`${name}-${option.value}`"
        v-model="modelValue"
        type="radio"
        :value="option.value"
        :aria-describedby="isErrored ? `${name}-error` : undefined"
        :aria-invalid="isErrored ? 'true' : 'false'"
        :name="name"
        class="radio-input"
      />
      <label :for="`${name}-${option.value}`" class="radio-label">
        <span class="radio-custom" :class="{ 'error-border': isErrored }"></span>
        <span :class="[darkMode ? 'text-text-light lg:text-text-dark' : 'text-text-dark']">
          {{ option.label }}
        </span>
      </label>
    </div>

    <p v-if="isErrored && errorText" :id="`${name}-error`" class="error-text">{{ errorText }}</p>
  </fieldset>
</template>

<script setup lang="ts">
const modelValue = defineModel<string | number>()

defineProps<{
  name: string
  options: { label: string; value: string | number }[]
  legend?: string
  errorText?: string
  isErrored?: boolean
  optional?: '' | string
  darkMode?: boolean
}>()
</script>

<style scoped>
.radio-group {
  @apply flex flex-col gap-3 border-none;
}

.radio-option {
  @apply flex items-center gap-2;
}

.radio-input {
  @apply absolute h-0 w-0 opacity-0;
}

.radio-label {
  @apply flex cursor-pointer items-center gap-2 text-base;
}

.radio-custom {
  transition: all 0.2s ease-in-out;
  @apply h-5 w-5 rounded-full border-[1.5px] border-solid border-brand-02 bg-background-03;
}

.radio-input:checked + .radio-label .radio-custom {
  @apply border-[7px] border-brand-01;
}

.error-text {
  @apply mt-1 text-xs text-states-error;
}
</style>
